import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-full bg-white rounded-xl px-6 pt-6 pb-8 flex flex-col justify-start" }
const _hoisted_2 = { class: "heading" }
const _hoisted_3 = { class: "t-22m text-wrh-blue-dark mb-6" }
const _hoisted_4 = { class: "space-y-2" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<li class=\"grid-cols-[minmax(130px,1fr),minmax(70px,1fr)] xxsm:grid-cols-[1fr,80px,90px] gap-1 justify-between items-center px-2 hidden xxsm:grid\"><span></span><span class=\"text-[11px] font-medium text-center\">Status</span><span class=\"text-[11px] font-medium text-center block xsm:hidden\">Date</span><span class=\"text-[11px] font-medium text-center hidden xsm:block\">Projected/<span class=\"block\">Completion Date</span></span></li>", 1)
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex items-center t-11r lg:t-14r" }
const _hoisted_8 = { class: "w-4 mdlg:w-6 mr-2" }
const _hoisted_9 = { class: "w-5 ml-auto" }
const _hoisted_10 = { class: "text-center col-start-2 col-end-4 xxsm:col-end-3" }
const _hoisted_11 = { class: "text-center col-start-2 col-end-4 xxsm:col-start-3 xxsm:col-end-4" }
const _hoisted_12 = {
  key: 0,
  class: "block lg:w-[60px] lg:mt-0 lg:inline-block t-10r mdlg:t-12b"
}
const _hoisted_13 = {
  key: 1,
  class: "block lg:w-[60px] lg:mt-0 lg:inline-block t-10r mdlg:t-12b"
}
const _hoisted_14 = {
  key: 0,
  class: "col-span-full mdlg:hidden"
}
const _hoisted_15 = {
  key: 0,
  class: "w-full bg-white rounded-xl px-6 pt-6 pb-8 hidden mdlg:block"
}

import {
  toRefs, PropType, ref, onMounted, watch,
} from 'vue';
import { useStore } from 'vuex';
import { ICheckList, IMilestone, IStep } from '@/models';
import {
  MyTimeLineStatus, StoreActions, Routes, Milestones,
} from '@/constants';
import { getChecklist } from '@/api';
import { checkStringEquality, formatDate } from '@/util/funcs';
import PostCard from '@/views/timeline/components/PostCard.vue';
import check from '@/components/icons/CheckIcon.vue';
import uncheck from '@/components/icons/UnCheckIcon.vue';
import Chevron from '@/components/icons/ChevronIcon.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  selectedMilestone: {
    type: Object as PropType<IMilestone>,
    required: true,
  },
  selectedCheckList: {
    type: Object as PropType<IStep>,
    required: true,
  },
  checklistClickEvent: {
    type: Boolean,
    required: true,
  },
},
  emits: ['selectedCheckListEmit'],
  setup(__props, { emit }) {

const props = __props


const store = useStore();


const { selectedMilestone, selectedCheckList } = toRefs(props);
const selectedCheckListItemData = ref<ICheckList>({} as ICheckList);
const accordian = ref<boolean>(false);
const appendChecklistName = ref('Checklist' as string);

const handleIsCheckListData = async () => {
  const checklists = store.getters.getCheckLists as ICheckList[];
  const isPresent = checklists.some((checklist) => {
    if (checklist.id === selectedCheckList.value.id) {
      selectedCheckListItemData.value = checklist;
      return true;
    }
    return false;
  });
  if (!isPresent && selectedCheckList.value.id) {
    const response = await getChecklist(selectedCheckList.value.id);
    selectedCheckListItemData.value = response;
    store.dispatch(StoreActions.SET_CHECKLIST, response);
  }
};

watch(selectedCheckList, async (value) => {
  if (selectedCheckList) {
    accordian.value = true;
    await handleIsCheckListData();
  }
});

watch(selectedMilestone, async (value) => {
  appendChecklistName.value = selectedMilestone.value.name && selectedMilestone.value.name.toLowerCase() === Milestones.CONSTRUCTION ? 'Schedule' : 'Checklist';
},
{
  deep: true,
  immediate: true,
});

onMounted(async () => {
  await handleIsCheckListData();
});

const handleOnClick = (checklist:IStep) => {
  if (checklist.checkListName === selectedCheckList.value?.checkListName) {
    accordian.value = !accordian.value;
  } else {
    emit('selectedCheckListEmit', checklist);
  }
};

const setTextClass = (checkListStatus = '', checkListName = '') => {
  let className = 'rounded-[100px] px-[10px] py-[3px] t-11r focus:outline-none ';
  if (checkStringEquality(checkListStatus, MyTimeLineStatus.DONE)) {
    className += 'bg-wrh-green-500 text-white  mdlg:t-11r';
  } else if (checkStringEquality(checkListStatus, MyTimeLineStatus.CURRENT)) {
    className += 'text-wrh-green-medium border mdlg:t-11r  border-wrh-green-medium';
  } else {
    // eslint-disable-next-line no-unused-expressions
    selectedCheckList.value.checkListName && checkStringEquality(checkListName, selectedCheckList.value.checkListName)
      ? className += 'text-wrh-green-medium border mdlg:t-11r border-wrh-green-medium'
      : className += 'text-wrh-gray-dark border mdlg:t-11r border-wrh-gray-dark';
  }
  return className;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["grid gap-6", [{'grid-cols-1 mdlg:grid-cols-2': __props.checklistClickEvent},{'w-full lg:w-1/2': !__props.checklistClickEvent}]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(selectedMilestone).name) + " " + _toDisplayString(appendChecklistName.value), 1)
      ]),
      _createElementVNode("ul", _hoisted_4, [
        _hoisted_5,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedMilestone).steps, (checklist, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            onClick: ($event: any) => (__props.checklistClickEvent ? handleOnClick(checklist): '')
          }, [
            _createElementVNode("ul", {
              class: _normalizeClass([_unref(checkStringEquality)(checklist.status, _unref(MyTimeLineStatus).DONE)? 'bg-wrh-green-background px-2 py-3 rounded text-wrh-gray-dark' :
              'bg-white px-2 py-3 shadow-modal rounded text-wrh-gray-dark',
                {'border-transparent border mdlg:border-wrh-green-medium transform scale-102': checklist.checkListName === _unref(selectedCheckList).checkListName},
                'grid grid-cols-[minmax(130px,1fr),minmax(70px,1fr)] xxsm:grid-cols-[1fr,80px,90px] gap-1 justify-between items-center cursor-pointer border-transparent border'])
            }, [
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (checklist.status?.toLowerCase() === _unref(MyTimeLineStatus).DONE)
                      ? (_openBlock(), _createBlock(check, {
                          key: 0,
                          class: "text-wrh-green-medium w-4 mdlg:w-6"
                        }))
                      : _createCommentVNode("", true),
                    (checklist.status?.toLowerCase() !== _unref(MyTimeLineStatus).DONE)
                      ? (_openBlock(), _createBlock(uncheck, {
                          key: 1,
                          class: "w-4 mdlg:w-6"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createTextVNode(" " + _toDisplayString(checklist.checkListName) + " ", 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(Chevron, {
                      class: _normalizeClass(["w-5 h-5 mdlg:hidden transition-transform", {'-rotate-180 transform': accordian.value && checklist.checkListName === _unref(selectedCheckList).checkListName }])
                    }, null, 8, ["class"])
                  ])
                ])
              ]),
              _createElementVNode("li", _hoisted_10, [
                _createElementVNode("button", {
                  class: _normalizeClass([setTextClass(checklist.status, checklist.checkListName)])
                }, _toDisplayString(checklist.status === _unref(MyTimeLineStatus).DONE ? 'Completed' : 'Projected Completion'), 3)
              ]),
              _createElementVNode("li", _hoisted_11, [
                (checklist.completionDate)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(formatDate)(checklist.completionDate)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_13, "Not Available"))
              ]),
              (__props.checklistClickEvent)
                ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                    ((accordian.value && checklist.checkListName === _unref(selectedCheckList).checkListName))
                      ? (_openBlock(), _createBlock(PostCard, {
                          key: 0,
                          selectedCheckListItemData: selectedCheckListItemData.value
                        }, null, 8, ["selectedCheckListItemData"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ], 8, _hoisted_6))
        }), 128))
      ])
    ]),
    (__props.checklistClickEvent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(PostCard, { selectedCheckListItemData: selectedCheckListItemData.value }, null, 8, ["selectedCheckListItemData"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})